import { render, staticRenderFns } from "./fieldOrder.vue?vue&type=template&id=199b2248&scoped=true&"
import script from "./fieldOrder.vue?vue&type=script&lang=js&"
export * from "./fieldOrder.vue?vue&type=script&lang=js&"
import style0 from "./fieldOrder.vue?vue&type=style&index=0&id=199b2248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199b2248",
  null
  
)

export default component.exports